"use client"

import { create } from "zustand"

import type { ColourwayId } from "@/features/catalog/catalog"
import { useCart } from "@/features/cart/hooks/use-cart"
import { useCartDrawer } from "@/features/cart/hooks/use-cart-drawer"
import { comboKey, type StorefrontCombo } from "@/features/combos/combo"

// The combo page's picks, for the phone's bar, which sits outside the builder.
type ComboPicks = {
  slug: string | null
  colours: ColourwayId[]
  set: (slug: string, colours: ColourwayId[]) => void
}

export const useComboPicks = create<ComboPicks>()((set) => ({
  slug: null,
  colours: [],
  set: (slug, colours) => set({ slug, colours }),
}))

/** Puts the pack in these colours in the cart and opens it, focus returning to `from`. */
export function useAddCombo(combo: StorefrontCombo) {
  const addCombo = useCart((s) => s.addCombo)
  const showCart = useCartDrawer((s) => s.show)
  return (colours: ColourwayId[], from: HTMLElement) => {
    const picked = colours.map((id) => combo.product.colourways.find((c) => c.id === id)!)
    addCombo({
      id: `${comboKey(combo.slug)}:${colours.join("-")}`,
      productSlug: combo.product.slug,
      productName: combo.name,
      colourway: colours[0]!,
      colourwayName: picked.map((c) => c.name).join(" · "),
      sku: comboKey(combo.slug),
      image: combo.image,
      unitPrice: combo.price,
      qty: 1,
      combo: { slug: combo.slug, colours, skus: picked.map((c) => c.sku) },
    })
    showCart(from)
  }
}
